import { render, staticRenderFns } from "./SupplierCommunicationOverview.vue?vue&type=template&id=ecf80662&"
import script from "./SupplierCommunicationOverview.vue?vue&type=script&lang=js&"
export * from "./SupplierCommunicationOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports